import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import { formatValue } from "../../../utilities";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const UserByMethodChart = props => {
  const data = props.data;

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["Public", "Private"]}
        series={methods.map(method => ({
          name: method,
          color: styleConstants.categoryColors.methodColors[method],
          data: data
            .filter(datum => datum.method === method)
            .map(datum => datum.value)
        }))}
        reversedLegend={true}
        absolute={props.absolute}
        tooltipFormatter={function() {
          return `${this.key} ${this.series.name} Users: <strong>${formatValue(
            this.y
          )}</strong><br />Share of ${this.key} Users: <strong>${formatValue(
            this.percentage / 100,
            true
          )}</strong>`;
        }}
      />
    </div>
  );
};

UserByMethodChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool
};

export default memo(
  React.forwardRef((props, ref) => (
    <UserByMethodChart innerRef={ref} {...props} />
  ))
);
